export default __webpack_public_path__ + "static/media/upload-file.75aa861a.svg";